// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from './application';

import CarouselStimulusController from './components/stimulus_carousel.js';
import PoliticalExpositionController from './political_exposition_controller.js';
import TomSelectController from './tom_select_controller.js';
import SidebarController from './sidebar_controller.js';
import NestedFormController from './nested_form_controller.js';
import RedactorController from './redactor_controller.js';
import PasswordVisibilityController from './password_visibility_controller.js';
import ProjectSectionSelectorController from './admin/project_section_selector_controller.js';
import InvestFormController from './invest_form_controller.js';
import DistributorFormController from './admin/users/distributors/form_controller.js';
import GenerateTokenController from './generate_token_controller.js';
import CopyToClipboardController from './copy_to_clipboard_controller.js';
import ComputeTimetableController from './compute_time_table_controller.js';
import ProjectClassificationsController from './project_classifications_controller.js';
import UpdateProfileStatusModalController from './update_profile_status_modal_controller.js';
import UserSidebarController from './user_sidebar_controller.js';
import TabsProgressController from './tabs_progress_controller.js';
import KycFileBackSelectionMenuController from './users/profile_information/kyc_documents/file_back_selection_menu_controller.js'
import KycFileFeedbackController from './users/profile_information/kyc_documents/file_feedback_controller.js'
import OpenedModalController from './opened_modal_controller.js';
import AuthenticatorCodeController from './authenticator_code_controller.js';
import PinCodeSetupController from './pin_code_setup_controller.js';
import RedirectController from './redirect_controller.js';
import KycFormController from './users/profile_information/kyc_documents/form_controller.js';
import ChartController from './chart_controller.js';

application.register('chart', ChartController);
application.register('carousel-stimulus', CarouselStimulusController);
application.register('political-exposition', PoliticalExpositionController);
application.register('tom-select', TomSelectController);
application.register('sidebar', SidebarController);
application.register('nested-form', NestedFormController);
application.register('redactor', RedactorController);
application.register('password-visibility', PasswordVisibilityController);
application.register('project-section-selector', ProjectSectionSelectorController);
application.register('invest-form', InvestFormController);
application.register('distributor-form', DistributorFormController);
application.register('generate-token', GenerateTokenController);
application.register('copy-to-clipboard', CopyToClipboardController);
application.register('compute-timetable', ComputeTimetableController);
application.register('project-classifications', ProjectClassificationsController);
application.register('update-profile-status-modal', UpdateProfileStatusModalController);
application.register('user-sidebar', UserSidebarController);
application.register('tabs-progress', TabsProgressController);
application.register('kyc-file-back-selection-menu', KycFileBackSelectionMenuController);
application.register('kyc-file-feedback', KycFileFeedbackController);
application.register('opened-modal', OpenedModalController);
application.register('authenticator-code', AuthenticatorCodeController);
application.register('pin-code-setup', PinCodeSetupController);
application.register('redirect', RedirectController);
application.register('kyc-form', KycFormController);
